import { Component, inject } from '@angular/core';
import { TranslatePipe } from '../../../../../core/pipes/translate.pipe';
import { AuthService } from '../../../../../core/services/auth.service';

@Component({
  selector: 'app-broker-header',
  imports: [TranslatePipe],
  templateUrl: './broker-header.html',
  styleUrl: './broker-header.scss',
})
export class BrokerHeader {
  private authService = inject(AuthService);

  get isBrokerCompany(): boolean {
    return this.authService.getRole() === 'broker_company';
  }

  get portalTitleKey(): string {
    return this.isBrokerCompany
      ? 'brokerDashboard.header.companyPortal'
      : 'brokerDashboard.header.brokerPortal';
  }
}

